import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../../context-store";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import IdNameModel from "../../../../models/common/IdNameModel";
import ReleaseCandidatesModel from "../../../../models/admin/company/response/ReleaseCandidatesModel";
import toasterUtils from "../../../../utils/toaster-utils";
import ReleaseCandidatesSeachInputModel from "../../../../models/admin/company/request/ReleaseCandidatesSeachInputModel";
import { SortDirection } from "../../../../models/enums/SortDirectionEnum";
import modalUtils from "../../../../utils/modal-utils";
import adminCompanyService from "../../../../services/admin/admin-company-service";
import PagedListModel from "../../../../models/common/PagedListModel";
import ReleaseCandidateGridComponent from "./ReleaseCandidateGridComponent";
import ReleaseCandidatesRequestModel from "../../../../models/admin/company/request/ReleaseCandidatesRequestModel";
import { PagingEnum } from "../../../../models/enums/IAIEnum";
import masterDataService from "../../../../services/master-data-service";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { GuidEnum } from "../../../../models/enums/GuidEnum";

interface ReleaseCandidatesProps {
    companiesList: IdNameModel[];
    primarySkillList: IdNameModel[];
};

const ReleaseCandidatesComponent = (props: ReleaseCandidatesProps) => {
    const [candidatesPagedList, setCandidatesPagedList] = useState<PagedListModel<ReleaseCandidatesModel>>();
    const [candidatesList, setCandidatesList] = useState<ReleaseCandidatesModel[]>([]);
    const [refreshCandidates, setRefreshCandidates] = useState<number>(2);
    const [companySearch, setCompanySearch] = useState<string>(GuidEnum.Empty);
    const [primarySkillSearch, setPrimarySkillSearch] = useState<number>(0);
    const [nameFilter, setNameFilter] = useState<string>("");
    const [emailIdFilter, setEmailIdFilter] = useState<string>("");
    const [jobCodeFilter, setJobCodeFilter] = useState<string>("");
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CandidateName");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        clearSearch();
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const clearSearch = () => {
        setCandidatesList([]);
        setPrimarySkillSearch(0);
        setCompanySearch(GuidEnum.Empty);
        setRefreshCandidates(2);
    };

    const getSearchFilters = (nameFilter: string, emailIdFilter: string, jobCode: string, page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: ReleaseCandidatesSeachInputModel = {
            primarySkillId: primarySkillSearch,
            companyId: companySearch,
            candidateName: nameFilter,
            emailId: emailIdFilter,
            jobCode: jobCode,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getReleaseCandidates = (inputData: ReleaseCandidatesSeachInputModel) => {
        if (companySearch === "" || primarySkillSearch === 0 || companySearch === GuidEnum.Empty) {
            toasterUtils.showWarning("Please select Company, Primary Skill");
            return;
        }
        setRefreshCandidates(2);
        modalUtils.showLoader();
        adminCompanyService.getCandidatesToBeReleased(inputData).then((res) => {
            modalUtils.closeModal();
            setCandidatesList([]);
            setCandidatesPagedList(res);
            setCandidatesList(res.items);
            setRefreshCandidates(refreshCandidates * 5);
        }).catch((error) => {
            setRefreshCandidates(refreshCandidates * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onReleaseCandidateActionHandler = (objReleaseCandidate: ReleaseCandidatesRequestModel) => {
        modalUtils.showLoader();
        adminCompanyService.releaseCandidate(objReleaseCandidate).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, jobCodeFilter, page, pageSize, sortColumn, sortDirection));
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, jobCodeFilter, newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, jobCodeFilter, PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, jobCodeFilter, page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc));
    };

    const onFilterActionHandler = (filterColumn: string, filterValue: string) => {
        setPage(0);
        if (filterColumn === "CandidateName") {
            setNameFilter(filterValue);
            getReleaseCandidates(getSearchFilters(filterValue, emailIdFilter, jobCodeFilter, 0, pageSize, sortColumn, sortDirection));
        } else if (filterColumn === "EmailId") {
            setEmailIdFilter(filterValue);
            getReleaseCandidates(getSearchFilters(nameFilter, filterValue, jobCodeFilter, 0, pageSize, sortColumn, sortDirection));
        } else {
            setJobCodeFilter(filterValue);
            getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, filterValue, 0, pageSize, sortColumn, sortDirection));
        }
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={props.companiesList} value={props.companiesList.find((x) => x.guId === companySearch) || null}
                                onChange={(_, newValue) => setCompanySearch(newValue ? newValue.guId : GuidEnum.Empty)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Company" size="small" margin="normal" fullWidth required />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-3">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={props.primarySkillList} value={props.primarySkillList.find((x) => x.id === primarySkillSearch) || null}
                                onChange={(_, newValue) => setPrimarySkillSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField {...params} label="Primary Skill" size="small" margin="normal" fullWidth required />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-3">
                        <Button variant="contained" color="success" onClick={() => getReleaseCandidates(getSearchFilters(nameFilter, emailIdFilter, jobCodeFilter, page, pageSize, sortColumn, sortDirection))} startIcon={<SearchIcon />} sx={{ ml: 2, mt: 2 }}>
                            Search
                        </Button>
                        <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2, mt: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {candidatesList.length > 0 && refreshCandidates > 2 &&
                    <ReleaseCandidateGridComponent
                        key={refreshCandidates}
                        candidateList={candidatesList}
                        totalSize={candidatesPagedList?.totalCount ? candidatesPagedList?.totalCount : candidatesList.length}
                        currentPage={page + 1}
                        pagesize={pageSize}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                        pageSizesList={pageSizesList}
                        nameFilterValue={nameFilter}
                        emailIdFilterValue={emailIdFilter}
                        jobCodeFilterValue={jobCodeFilter}
                        onReleaseCandidateAction={onReleaseCandidateActionHandler}
                        onPageChangeAction={onPageChangeActionHandler}
                        onPageSizeChangeAction={onPageSizeChangeActionHandler}
                        onSortAction={onSortActionHandler}
                        onFilterAction={onFilterActionHandler} />
                }
            </div>
        </div>
    );
};
export default ReleaseCandidatesComponent;